var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-carousel",
    {
      attrs: {
        cycle: "",
        height: "110",
        "hide-delimiters": "",
        "show-arrows": false,
        light: ""
      }
    },
    _vm._l(_vm.elementos, function(slide, i) {
      return _c(
        "v-carousel-item",
        { key: i },
        [
          _c(
            "v-sheet",
            { attrs: { color: "white", height: "100%" } },
            [
              _c("v-row", { staticClass: "container" }, [
                _c("p", { staticClass: "titulo" }, [
                  _vm._v(_vm._s(slide.titulo))
                ]),
                _c("p", { staticClass: "texto" }, [
                  _vm._v(_vm._s(slide.mensaje))
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }